import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedDevolucionesAgregarErroresItemComponent {
  data
  mostrarDetalles = false
  onDelete
}

module.component('viaticosSharedDevolucionesAgregarErroresItem', {
  controller: ViaticosSharedDevolucionesAgregarErroresItemComponent,
  template,
  bindings: {
    data: '<',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/devoluciones/agregar/errores/item/component.js